import { useNavigate } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useCreateStaff } from "../api/queries";
import { StaffForm } from "../ui/StaffForm";

export function StaffCreatePage() {
  const nav = useNavigate({ from: "/app/performance/staff/create" });
  const createStaff = useCreateStaff();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "Staff", to: "/app/performance/staff" },
            { label: "ເພີ່ມໃໝ່" },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6">
          <h2 className="font-bold text-2xl tracking-tight">ເພີ່ມ Staff</h2>
          <p className="text-muted-foreground">
            ສ້າງລາຍຊື່ Staff ໃນລະບົບ — ດຶງຂໍ້ມູນຈາກນັກສະແດງທີ່ມີຢູ່ໄດ້ ຫຼື ປ້ອນໃໝ່
          </p>
        </div>

        <div className="rounded-xl border bg-card px-6">
          <StaffForm
            onSubmit={async (vals) => {
              try {
                const created = await createStaff.mutateAsync(vals);
                nav({
                  to: "/app/performance/staff/$id/edit",
                  params: { id: created.id },
                });
              } catch {}
            }}
            onCancel={() => nav({ to: "/app/performance/staff" })}
            submitting={createStaff.isPending}
          />
        </div>
      </Main>
    </>
  );
}
